import React from "react"
import MastermindComponent from "../../games/mastermind"

export default function Mastermind() {
  return <MastermindComponent />;
}
